"use strict";

// Copyright 2022 Fewcha. All rights reserved.
var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
class Web3Provider {
  constructor(provider) {
    _defineProperty(this, "provider", void 0);
    this.provider = provider;
    return this;
  }
}
exports.default = Web3Provider;